module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/680b3ff6a51d8fc77fbaf8695c8de929.svg";